module.exports = __webpack_public_path__ + "ath_game_web/img/5.6.00b7ec72.png";